import {transformNameToTransliteration} from '@utils/transformNameToTransliteration';

import {parsePage} from './parsePage';

export const entityToPathSegment = (
  entityId: number | string,
  entityName: string,
) => {
  const transformedName = transformNameToTransliteration(entityName);

  return [transformedName, entityId].join('-');
};

export const pageParamsToEntityIdAndPage = (
  entityPathSegment: string,
  pagination: string,
) => {
  return {
    entityId: Number.parseInt(entityPathSegment.split('-').at(-1) || ''),
    pageNumber: parsePage(pagination),
  };
};
